import React, {Component} from 'react';
import {connect} from 'react-redux';

// Components
import {Card, Grid, Tooltip} from '@material-ui/core';
import Counter from 'Components/counter/Counter';
import BasicButton from 'Components/common/BasicButton';
import ProductImage from 'Components/commonOrder/ProductImage';
import {T} from 'Actions/translate';
import {Info} from '@material-ui/icons';

class InventroyCard extends Component {
    state = {
        num: 0,
    };

    componentDidMount() {
        const {inventroyDetails} = this.props;
        if (
            inventroyDetails['autoStockQuantity'] &&
            Number(inventroyDetails['autoStockQuantity']) > 0
        ) {
            this.setState({
                num: inventroyDetails['autoStockQuantity'],
            });
        }
    }

    changeNum = (value) => {
        this.setState({
            num: value,
        });
        if (this.props.changeNum) {
            this.props.changeNum(this.props.inventroyDetails, value);
        }
    };

    clearNum = async (e) => {
        const {num} = this.state;
        const {inventroyDetails} = this.props;

        if (
            num == 0 &&
            inventroyDetails['autoStockQuantity'] &&
            Number(inventroyDetails['autoStockQuantity']) > 0
        ) {
            const res = await this.props.addFOneShoppingCart(
                this.props.inventroyDetails,
                num,
                e,
            );
            if (res === 'success') {
                this.setState({
                    num: 0,
                });
            }
        } else if (num > 0) {
            const res = await this.props.addFOneShoppingCart(
                this.props.inventroyDetails,
                num,
                e,
            );
            if (res === 'success') {
                this.setState({
                    num: 0,
                });
            }
        }
    };

    render() {
        const {inventroyDetails, localData, numProps, successAll} = this.props;
        const {num} = this.state;

        return (
            <Card className="inventroy-card">
                <Grid className="top-content-container" container spacing={0}>
                    <Grid className="sku-details-grid" container spacing={0}>
                        <Grid item xs={12} className="sku-value-grid">
                            <span>{inventroyDetails.sku}</span>
                            {inventroyDetails.grayFlag === 'Y' ? (
                                //    <Tooltip title={T('notification_gray_list_info')} aria-label={T('notification_gray_list_info')}>
                                //       <Info title='gray list' className="sku-info"/>
                                //    </Tooltip>
                                <div className="gray-sku-info">
                                    <Info className="sku-info" />
                                    {T('notification_gray_list_info')}
                                </div>
                            ) : null}
                        </Grid>
                    </Grid>

                    <Grid className="inventory-content-container" item xs={12}>
                        <Grid className="image-grid" item xs={4}>
                            <div className="image-box">
                                <ProductImage
                                    src={inventroyDetails.productPic}
                                    alt={inventroyDetails.productName}
                                    key={inventroyDetails.productPic}
                                />
                            </div>
                        </Grid>

                        <Grid className="left-content-grid" item xs={4}>
                            <Grid
                                className="inventroy-details-grid"
                                container
                                spacing={0}>
                                <Grid item xs={12}>
                                    <span className="left-content-grid-red">
                                        {T('fone_order_replenishing_colon')}
                                        {inventroyDetails.replenishingQuantity}
                                    </span>
                                </Grid>

                                {localData.roleType === 3 ? null : (
                                    <Grid item xs={12}>
                                        <span className="left-content-grid-red">
                                            {T('fone_order_out_of_stock_colon')}
                                            {
                                                inventroyDetails[
                                                    'stockoutQuantity'
                                                ]
                                            }
                                        </span>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <span className="left-content-grid-red">
                                        {T('fone_order_wait_delivery_colon')}
                                        {inventroyDetails.tobeshippedQuantity}
                                    </span>
                                </Grid>

                                {localData.roleType === 1 ? (
                                    <Grid item xs={12}>
                                        <span className="left-content-grid-red">
                                            {T(
                                                'fone_order_hold_delivery_colon',
                                            )}
                                            {inventroyDetails.onholdQuantity}
                                        </span>
                                    </Grid>
                                ) : null}

                                <Grid item xs={12}>
                                    <span className="left-content-grid-red">
                                        {T('fone_order_backup_quantity')}
                                        {inventroyDetails['stockUpQuantity']}
                                    </span>
                                </Grid>

                                {localData.roleType === 3 ? (
                                    <Grid item xs={12}>
                                        <span className="right-content-grid-grey">
                                            {T(
                                                'fone_order_current_locking_colon',
                                            )}
                                            {
                                                inventroyDetails.skuOnholdInventory
                                            }
                                        </span>
                                    </Grid>
                                ) : null}
                            </Grid>
                        </Grid>

                        <Grid className="right-content-grid" item xs={4}>
                            {localData.roleType === 3 ? (
                                <Grid item xs={12}>
                                    <span className="right-content-grid-grey">
                                        {T('fone_order_available_stock')}
                                        {inventroyDetails.physicalInventory}
                                    </span>
                                </Grid>
                            ) : null}
                            <Grid
                                className="inventroy-details-grid"
                                container
                                spacing={0}>
                                {localData.roleType === 3 ? null : (
                                    <Grid item xs={12}>
                                        <span className="right-content-grid-grey">
                                            {T('fone_order_available_stock')}
                                            {inventroyDetails.physicalInventory}
                                        </span>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <span className="right-content-grid-grey">
                                        {T('fone_order_current_actual_colon')}
                                        {inventroyDetails.totalInventory}
                                    </span>
                                </Grid>

                                {localData.roleType === 1 ? (
                                    <Grid item xs={12}>
                                        <span className="right-content-grid-grey">
                                            {T(
                                                'fone_order_current_locking_colon',
                                            )}
                                            {
                                                inventroyDetails.skuOnholdInventory
                                            }
                                        </span>
                                    </Grid>
                                ) : null}

                                <Grid item xs={12}>
                                    <span className="right-content-grid-grey">
                                        {T('fone_order_max_inventory_colon')}
                                        {inventroyDetails.maxInventory}
                                    </span>
                                </Grid>
                                <Grid item xs={12}>
                                    <span className="right-content-grid-grey">
                                        {T(
                                            'fone_order_security_inventory_colon',
                                        )}
                                        {inventroyDetails.safetyInventory}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    className="bottom-content-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {localData.roleType === 3 ? null : (
                        <React.Fragment>
                            <Grid item xs={4}></Grid>
                            {successAll == 'success' ? (
                                <Grid className="counter" item xs={4}>
                                    <Counter
                                        inputValid={this.changeNum}
                                        defalutValue={numProps}
                                        options={{value: 0, min: 0}}></Counter>
                                </Grid>
                            ) : (
                                <Grid className="counter" item xs={4}>
                                    <Counter
                                        inputValid={this.changeNum}
                                        defalutValue={numProps}
                                        options={{value: 0, min: 0}}></Counter>
                                </Grid>
                            )}
                            <Grid className="add-to-shopping-cart" item xs={4}>
                                <BasicButton
                                    onClickOfSingleTap={(e) => {
                                        this.clearNum(e);
                                    }}>
                                    {T('fone_order_add_to_cart')}
                                </BasicButton>
                            </Grid>
                            <Grid
                                className="page-bottom-container container-max-width is-fixed no-margin"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={5}></Grid>
                                <Grid className="add-cart-button" item xs={6}>
                                    <BasicButton
                                        type="primary"
                                        onClickOfSingleTap={this.props.addAll.bind(
                                            this,
                                        )}>
                                        <span>
                                            {T('fone_order_total_add_cart')}
                                        </span>
                                    </BasicButton>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    )}
                </Grid>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;

    return {
        localData,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InventroyCard);
